import styled, { css } from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';

interface Props {
    checked: boolean;
    width?: number;
}

export const CheckBoxWrapper = styled.div<Props>`
    position: relative;
    height: 44px;
    border-radius: 8px;
    border: 1px solid ${ifProp('checked', palette('blue_900'), palette('gray_opacity_400'))};
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.width ? css`${props.width}px;` : '100%;'}
    ${(props) => props.checked ?
        css`
        background: ${palette('blue_opacity_100')};
            ${CheckBoxLabel}{
                color: ${palette('blue_900')};
            }
        ` : null
    }
`;

export const CheckBox = styled.input`
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
`;

export const IconWrapper = styled.div`
    margin-right: 4px;
`;

export const CheckBoxLabel = styled.label`
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_600')}
`;

